import axios from 'axios'
import {ID} from '../../../../../../_metronic/helpers'
import {Comment} from './_models'

const API_URL = process.env.REACT_APP_API_URL + '/comment'

const createComment = (comment: Comment): Promise<Comment | undefined> => {
  return axios.post(API_URL, comment)
}

const updateComment = (comment: Comment): Promise<Comment | undefined> => {
  return axios.patch(`${API_URL}/${comment.id}`, comment)
}

const deleteComment = (commentId: ID): Promise<void> => {
  return axios.delete(`${API_URL}/${commentId}`)
}

export {deleteComment, createComment, updateComment}
